import React from 'react';
import { Button } from 'react-bootstrap';

interface FormActionsProps {
  onBack?: () => void;
  onSave?: () => void;
  saveText?: string;
}

const FormActions = ({
  onBack = () => {},
  onSave = () => {},
  saveText = 'Save & Next',
}: FormActionsProps) => (
  <div className="mt-5 d-flex justify-content-between mb-5">
    <Button className="button-style" variant="success" onClick={onBack}>
      Back
    </Button>
    <Button className="button-style" variant="success" onClick={onSave}>
      {saveText}
    </Button>
  </div>
);

export default FormActions;
